// extracted by mini-css-extract-plugin
module.exports = {"paper":"_6o3-vITt"};